import { render, staticRenderFns } from "./JoinSubTaskInfo.vue?vue&type=template&id=940156ca&"
import script from "./JoinSubTaskInfo.vue?vue&type=script&lang=js&"
export * from "./JoinSubTaskInfo.vue?vue&type=script&lang=js&"
import style0 from "./JoinSubTaskInfo.vue?vue&type=style&index=0&id=940156ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports